// extracted by mini-css-extract-plugin
export var actionsReverse = "Modal-module--actionsReverse--e581e";
export var actionsWrap = "Modal-module--actionsWrap--320b4";
export var centeredModal = "Modal-module--centeredModal--b0cc5";
export var hasFooterContent = "Modal-module--hasFooterContent--cd937";
export var hasHeaderContent = "Modal-module--hasHeaderContent--0c557";
export var modalActions = "Modal-module--modalActions--15e42";
export var modalBody = "Modal-module--modalBody--4136d";
export var modalContentWrapper = "Modal-module--modalContentWrapper--6a5b7";
export var modalFooter = "Modal-module--modalFooter--b8c02";
export var modalHeaderContent = "Modal-module--modalHeaderContent--f8fa5";
export var modalTitle = "Modal-module--modalTitle--24fb4";
export var modalcontent = "Modal-module--modalcontent--290ae";